module.exports = __webpack_public_path__ + "img/Posada-cabo_0004_room1.5d899972.jpg";